import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from "@angular/core";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { provideRouter, RouteReuseStrategy, withComponentInputBinding, withRouterConfig } from "@angular/router";
import { provideAuth, withAppInitializerAuthCheck } from "angular-auth-oidc-client";
import { ComponentRouteReuseStrategy, routes } from "routing";
import { authInterceptor } from "src/app/interceptors/auth.interceptor";
import { openIdConfigFactory } from "./oidc.config";
import { AppConfiguration, APP_CONFIG } from "../types/app-configuration";
import { API_BASE_URL } from "../services/application-api.service";
import { GlobalErrorHandler } from "../interceptors/error-handler.interceptor";
import { provideAnimations } from "@angular/platform-browser/animations";

export function appConfigFactory(config: AppConfiguration): ApplicationConfig {
  return {
    providers: [
      { provide: APP_CONFIG, useValue: config },
      provideRouter(
        routes,
        withComponentInputBinding(),
        withRouterConfig({ paramsInheritanceStrategy: 'always' })
      ),
      provideHttpClient(
        withInterceptors([authInterceptor])
      ),
      provideAnimations(),
      provideAuth(
        { config: openIdConfigFactory(config) },
        withAppInitializerAuthCheck()
      ),
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideNativeDateAdapter(),
      { provide: ErrorHandler, useClass: GlobalErrorHandler },
      { provide: RouteReuseStrategy, useClass: ComponentRouteReuseStrategy },
      { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } },
      { provide: API_BASE_URL, useValue: config.apiRootUrl }
    ]
  };
}
